import type { FaireProductEntity } from "../../entity_types/product";

export const p_qrnvqu4han: FaireProductEntity = {
  token: "p_qrnvqu4han",
  type: "product",
  name: "Custom Embroidered Toddler and Kids Sweatshirts Logo Brand",
  brandToken: "b_bftwxtye3z",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/973474aa47063c01ce59e7537a64c4ad9f04098487b78e658aa69f42d118cfee.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3df2468c4968293c89133a850f50c6fb179f203c9b9887e20b6a736c6ad7cced.png",
    "https://cdn.faire.com/fastly/85b3b4e472b85a16cca9bb07c01bf548b2793aabd7021905d5fef9754e75d9f6.png",
    "https://cdn.faire.com/fastly/f8aedfb79d97d69831cce318f5484c3be560c937ef94a892c0d7fd9857101262.png",
    "https://cdn.faire.com/fastly/582b0074e5e411f4f5adf1416f3c6e3d63ad618de83967f66a40e223bc282021.png",
    "https://cdn.faire.com/fastly/5b7d3618c4ca51f72eaf2941c7a7b9babdbc8ead6e81a0b937f769bba9f62709.jpeg",
    "https://cdn.faire.com/fastly/e877bf4071d679853e98110f302e367ea800a36c6cb85484665c057003221193.jpeg",
    "https://cdn.faire.com/fastly/528d54cb485e39d5b95d2884c2bdf4536795a65aec3384b69abb2c46db2a2c3f.jpeg",
  ],
  priceDollars: 27.58,
  description:
    "Custom Toddler and Youth Embroidered sweatshirts. \n\nPlease add --- \n1- Font #\n2- Embroidery Color \n3- Phrase (top line)\n4- Phrase (bottom line)\n\n\nIf you are interested in having your LOGO embroidered there will be a one time digitizing fee. Re-orders with the same logo will not be charged again. :) \n\nReach out with any questions! \n\nSweatshirt Details - \n7.4 oz./yd², 60/40 combed ring-spun cotton/polyester\n3-end fleece\nRibbed collar, hem and cuffs\nBack locker patch\nEasyTear™ label",
  tags: [],
  msrpDollars: 55.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:21.636Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
